// HomeNewsList component for Sitecore JSS
import styles from './HomeNewsList.module.scss';
import cn from 'classnames';
import React, { memo } from 'react';
import OptimizedImage from '../../../../../../ui/OptimizedImage/OptimizedImage';

const MAX_TITLE_LENGTH = 87;

// 安全获取文本内容，处理对象和字符串
const getTextContent = (textObj) => {
  if (!textObj) return 'READ';
  if (typeof textObj === 'string') return textObj;
  if (typeof textObj === 'object' && textObj.value) return textObj.value;
  return 'READ';
};
// 工具函数：安全地截断标题
const truncateTitle = (title) => {
  if (!title) return '';
  return title.length > MAX_TITLE_LENGTH ? title.slice(0, MAX_TITLE_LENGTH) + '...' : title;
};

// 工具函数：安全地提取图片URL
const getImageSrc = (fields, imageUrl) => {
  const imageField = fields?.detail?.fields?.image || fields?.image || { value: { src: imageUrl } };
  return imageField?.value?.src || imageUrl || '';
};

// 工具函数：渲染新闻项内容
const NewsItemContent = ({
  id,
  url,
  title,
  imageSrc,
  hoverPosition,
  onMouseMove,
  onMouseLeave,
  readText,
}) => {
  const content = (
    <div
      className={styles.item}
      onMouseMove={(e) => onMouseMove(e, id)}
      onMouseLeave={onMouseLeave}
    >
      <OptimizedImage
        src={imageSrc}
        alt={title || 'News image'}
        width={600}
        height={400}
        loading="lazy"
        quality={75}
        device="desktop"
        objectFit="cover"
        className={styles.image}
      />
      <p className={styles.title} data-aos="fade-up" data-aos-offset="100">
        {truncateTitle(title)}
      </p>
      {hoverPosition && hoverPosition.id === id && (
        <span
          className={styles.circle}
          style={{
            left: `${hoverPosition.x}px`,
            top: `${hoverPosition.y}px`,
          }}
        >
          {readText}
        </span>
      )}
      <div
        className={cn(
          styles.overlay,
          hoverPosition && hoverPosition.id === id && styles.overlay_show
        )}
      />
    </div>
  );

  return url ? (
    <a href={url} className={styles.link}>
      {content}
    </a>
  ) : (
    content
  );
};

const List = memo(function List({
  articles = [],
  hoverPosition,
  onMouseMove,
  onMouseLeave,
  readText,
}) {
  const readTextContent = getTextContent(readText);
  // 空数据检查
  if (!articles || articles.length === 0) {
    return (
      <div id="item-set" className={styles.list}>
        <p className={styles.emptyMessage}>No articles available</p>
      </div>
    );
  }

  return (
    <div id="item-set" className={styles.list}>
      {articles.map(({ id, url, title, imageUrl, fields }) => {
        const imageSrc = getImageSrc(fields, imageUrl);
        // 图片URL验证
        if (!imageSrc) {
          console.warn(`Missing image source for article: ${id}`);
        }

        return (
          <div key={id}>
            <NewsItemContent
              id={id}
              url={url}
              title={title}
              imageSrc={imageSrc}
              hoverPosition={hoverPosition}
              onMouseMove={onMouseMove}
              onMouseLeave={onMouseLeave}
              readText={readTextContent}
            />
          </div>
        );
      })}
    </div>
  );
});

export default List;
